import React, { useEffect, useState } from 'react'
import { publicRoute } from '../../routes/RoutePublic'
import { Link } from 'react-router-dom'
import UseTranslationHook from '../../hooks/UseTranslationHook'
import ICImage from '../../core-component/ICImage'
import { addressIcon, emailIcon, phoneCallIcon, rightArrow, rightArrowBlackIcon, rightArrowIcon, rightChevronIcon, xIcon } from '../../assets/icons/SvgIconList'
import ICPureImage from '../../core-component/ICPureImage'
import { IElement, INewsletter, fetchContactDetails, handleSubmitNewsletter } from '../../public/contact-us/ContactUsViewController'
import { APP_CONTENT_TYPE, CONTACT_US_TYPE } from '../../utils/AppEnumerations'

const CopyrightFooter = () => {
    const { t } = UseTranslationHook();
    const [contactUs, setContactUs] = useState<IElement[]>([]);
    const [loading, setLoading] = useState(false);
    const [emailValue, setEmailValue] = useState<string>("");
    const [emailError, setEmailError] = useState('');
    useEffect(() => {
        fetchContactDetails(setContactUs, APP_CONTENT_TYPE.VPContact)
    }, [])
    const handleNewsletter = (value: string) => {
        if (!validateEmail(value)) {
            setEmailError(t("Please enter a valid email address."));
            return;
        }
        else {
            handleSubmitNewsletter(value, setLoading).then(() => {
                setEmailValue("");
                setEmailError('');
            })
        }
        setEmailError('');
    }
    const validateEmail = (value: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(value).toLowerCase());
    };
    return (
        <div className='text-skin-insights'>
            <hr />
            <div className='flex md:justify-center justify-start tracking-widest w-full px-4 pt-4 pb-8'>
                <div className='grid grid-cols-12 w-full overflow-hidden mt-6'>
                    {/* keep it will need in future */}
                    {/* <div className='lg:col-span-4 col-span-12 h-full w-full'>
                        <div className='flex flex-col  h-full w-full'>
                            <div className='flex h-full w-full lg:justify-start justify-center'>
                                <Link to={publicRoute.home}>
                                    <ICPureImage
                                        src={require("../../assets/image/vp-logo-sqaure.png")}
                                        className='h-[350px] w-[650px] object-contain z-[999]'
                                    />
                                </Link>
                            </div>
                        </div>
                    </div> */}
                    <div className='lg:col-span-12 col-span-12 leading-7'>
                        <div className='grid grid-col-12 w-full h-full'>
                            <div className='flex lg:flex-row flex-col lg:gap-20 justify-center h-full gap-10'>
                                <div className='lg:col-span-2 md:col-span-4 col-span-12'>
                                    <div className='flex flex-col gap-10'>
                                        <div className='text-2xl font-bold'>{t("important_links")}</div>
                                        <div className='flex flex-col gap-6'>
                                            <div><Link to={publicRoute.home}>{t("home")}</Link></div>
                                            <div><Link to={`/${publicRoute.offerings}`}>{t("offerings")}</Link></div>
                                            <div><Link to={`/${publicRoute.insights}`}>{t("insights")}</Link></div>
                                            <div><Link to={`/${publicRoute.events}`}>{t("events")}</Link></div>
                                            {/* <div><Link to={`/${publicRoute.aboutUs}`}>{t("get_to_know_us")}</Link></div> */}
                                            <div><Link to={`/${publicRoute.contactUs}`}>{t("get_in_touch")}</Link></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='lg:col-span-2 md:col-span-4 col-span-12'>
                                    <div className='flex flex-col gap-10'>
                                        <div className='text-2xl font-bold'>{t("legal_terms")}</div>
                                        <div className='flex  flex-col gap-6'>
                                            <div><Link to={`/${publicRoute.privacyPolicy}`} target='_blank'>{t("privacy_policy")}</Link></div>
                                            <div><Link to={`/${publicRoute.termsAndCondition}`} target='_blank'>{t("terms_and_condition")}</Link></div>
                                        </div>
                                    </div>
                                </div>

                                {contactUs && contactUs.length > 0 &&
                                    <div className='lg:col-span-2 md:col-span-4 lg:w-1/3 w-full col-span-12'>
                                        <div className='flex flex-col gap-10'>
                                            <div className='text-2xl font-bold'>{t("get_in_touch")}</div>
                                            <div className='flex flex-col gap-6'>
                                                {contactUs && contactUs.length > 0 && contactUs.map((item, index) => (
                                                    <div className='grid grid-cols-1'>
                                                        <div className='flex'>
                                                            <div className='w-6 h-6 mr-3'>
                                                                {item.type === CONTACT_US_TYPE.contact_number ? phoneCallIcon : item.type === CONTACT_US_TYPE.email_address ? emailIcon : addressIcon}
                                                            </div>
                                                            <div className='w-full'>
                                                                {item.type === CONTACT_US_TYPE.address ?
                                                                    <div>
                                                                        {item.value}
                                                                    </div>
                                                                    :
                                                                    <a href={item.type === CONTACT_US_TYPE.contact_number ? `tel:${item.value}` : item.type === CONTACT_US_TYPE.email_address ? `mailto:${item.value}` : ""}>
                                                                        <span className='text-skin-home-text'>{item.value}</span>
                                                                    </a>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="lg:col-span-2 social-menu flex justify-start flex-row h-full">
                                    <ul className='w-full h-full flex lg:flex-col flex-row lg:gap-5 justify-start'>
                                        <li className=''><Link to="https://www.instagram.com/vprosper_official/" target="_blank"><i className="fab fa-instagram"></i></Link></li>
                                        <li><Link to="https://www.linkedin.com/in/v-prosper-920333312/" target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                                        <li className=''>
                                            <Link to="https://x.com/vprosper_in/" target="_blank" className='flex justify-center items-center w-full h-full'>
                                                <div className='p-4 w-full h-7'>
                                                    {xIcon}
                                                </div>
                                            </Link>
                                        </li>
                                        <li><Link to="https://www.facebook.com/profile.php?id=61560278146286" target="_blank"><i className="fab fa-facebook"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-skin-insights-card tracking-widest'>
                <hr />
                <div className='flex justify-center flex-col items-center'>
                    <div className='grid grid-cols-12 mt-6 lg:w-3/4 w-full'>
                        <div className='flex lg:col-span-12 mb-6 col-span-12 w-full items-center justify-center  gap-6'>
                            <div className='px-5'>
                                <div className='lg:text-3xl text-xl text-center w-full'>{t("get_notified_live")}</div>
                                <div className='text-lg mt-4 text-center'>{t("miss_out")}</div>
                            </div>
                        </div>
                    </div>
                    <div className='grid grid-cols-12 lg:w-1/3 w-full' id="h-footer">
                        <div className='lg:col-span-12 col-span-12  flex justify-center'>
                            <div className='w-full px-3 relative'>
                                <input type="text" value={emailValue} onChange={(event) => setEmailValue(event.target.value)} className='lg:h-16 h-12 p-4 w-full z-[999]  border-white rounded-full bg-skin-insights-card' placeholder={t('contact_email_address')} />
                                <div className='absolute right-3 w-[14%] top-0 lg:rounded-full rounded-3xl flex h-full bg-white justify-center items-center cursor-pointer' onClick={() => handleNewsletter(emailValue)}>
                                    <div className=' w-8 h-8'>
                                        {rightArrowBlackIcon}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {emailError && <div className="text-red-500 mt-2">{emailError}</div>}
                </div>
                <div className='w-full flex flex-col justify-center gap-3 items-center mt-6'>
                    <ICPureImage
                        width={120}
                        src={require("../../assets/image/vprosper_qr.png")}
                        className='object-contain rounded-lg'
                    />
                    <span className='text-skin-insights lg:text-lg text-sm'>{t("scan_share")}</span>
                </div>
                <div className='flex justify-center mt-6 w-full'><p>{t("made_with")} <span className='heart'>❤️</span> {t("by_vprosper")}</p></div>
                <div className='bg-skin-insights-card pb-1 mt-6 tracking-normal xl:flex justify-center '>
                    <div className='flex justify-center'>
                        <div className='mr-1'>{t("copyright")} |</div>
                        <Link to={`/${publicRoute.privacyPolicy}`} target="_blank" className='mr-1'> {t("privacy_policy")} |</Link>
                    </div>
                    <div className='flex justify-center mr-1'>
                        <Link to={`/${publicRoute.termsAndCondition}`} target="_blank">{t("terms_and_condition")}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CopyrightFooter